import React, { useContext } from 'react'

import Price from '../../../../../src/Organisms/Price'
import { Button, Placeholder, Tooltip } from '@s4l/ds'
import type { Availability } from '@s4l/stayforlong/booking/Availability'
import { RoomConfiguratorContext } from '../../context'
import { IconArrowRight } from '@s4l/icons/IconArrowRight'
import { useS4LContext } from '@s4l/react-context'

import styles from './styles.module.css'
import { Spinner } from '../../../../../../ds/src/Atoms/Loader/Spinner'
import PriceDetails from '../../../../Organisms/PriceDetails'

interface IFooterProps {
  availability?: Availability
  disabled?: boolean
  loadingBookingRule?: boolean
}

function Footer({ availability, disabled, loadingBookingRule }: Readonly<IFooterProps>) {
  const { listOfAvailability, isMultiBooking } = useContext(RoomConfiguratorContext)
  const { i18n } = useS4LContext()

  if (!availability) {
    return null
  }

  const isPurchasable = availability.isPurchasable()

  const getButtonLabel = () => {
    const soldOutText = i18n.formatMessage({ id: 'global.sold-out' })
    const soldOutTextFormatted = soldOutText.at(0)?.toUpperCase() + soldOutText.slice(1)
    if (!isPurchasable) {
      return soldOutTextFormatted
    }
    return isMultiBooking
      ? i18n.formatMessage({ id: 'global.select' })
      : i18n.formatMessage({ id: 'global.book' })
  }

  return (
    <footer className={styles.container}>
      <span className={styles.priceContainer}>
        <Price
          nights={listOfAvailability.getNights()}
          price={availability.price()}
          featuredInfoSlot={
            loadingBookingRule ? (
              <Spinner iconOnly color="var(--color--primary--500)" />
            ) : (
              <PriceDetails
                nights={listOfAvailability.getNights()}
                rooms={[availability.toRoomDetail()]}
              />
            )
          }
        />
      </span>
      <Tooltip enabled={!isPurchasable}>
        <Tooltip.Trigger>
          <Button
            data-testid="button-book-room"
            type="submit"
            disabled={disabled || !isPurchasable}
            variant="filled-rounded"
            size="medium"
            trailingIcon={<IconArrowRight />}
          >
            {getButtonLabel()}
          </Button>
        </Tooltip.Trigger>
        <Tooltip.Content side="bottom">
          {i18n.formatMessage({ id: 'step-error.already-booked' })}
        </Tooltip.Content>
      </Tooltip>
    </footer>
  )
}

function FooterPlaceholder() {
  return (
    <footer className={styles.container}>
      <Placeholder width="150px" height="40px" rounded />
      <Placeholder width="150px" height="40px" rounded />
    </footer>
  )
}

Footer.displayName = 'RoomConfigurator.Form.Footer'
FooterPlaceholder.displayName = 'RoomConfigurator.Form.Footer.Placeholder'

Footer.Placeholder = FooterPlaceholder

export default Footer
